function Privacy() {
    return ( 
        <>
            <section className="terms-n-policy container">
                <h1>Privacy Policy</h1>
                <p>Last Updated: 10.02.2025</p>

                <br />

                <h2>1. Introduction</h2>
                <p>Welcome to OnlyGlance.com. Your privacy is important to us, and this Privacy Policy explains how we collect, use, and protect your information.</p>

                <h2>2. Information We Collect</h2>
                <p>We only collect email addresses that users voluntarily provide to receive content from us.</p>

                <h2>3. How We Use Your Information</h2>
                <p>We use collected emails solely for the purpose of sending content and updates related to our services.</p>

                <h2>4. Data Protection</h2>
                <p>We implement appropriate security measures to protect your email from unauthorized access, disclosure, or misuse.</p>

                <h2>5. Third-Party Sharing</h2>
                <p>We do not sell, trade, or share your email address with third parties.</p>

                <h2>6. Your Rights</h2>
                <p>You can request to remove your email from our database at any time by contacting us at <a href="mailto:contact@onlyglance.com">contact@onlyglance.com</a>.</p>

                <h2>7. Changes to This Policy</h2>
                <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page.</p>

                <h2>8. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:contact@onlyglance.com">contact@onlyglance.com</a>.</p>
            </section>
        </>
     );
}

export default Privacy;